import { render } from "./MailSuccessErrorModal.vue?vue&type=template&id=1c794ab1&scoped=true"
import script from "./MailSuccessErrorModal.vue?vue&type=script&lang=js"
export * from "./MailSuccessErrorModal.vue?vue&type=script&lang=js"

import "./MailSuccessErrorModal.vue?vue&type=style&index=0&id=1c794ab1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c794ab1"]])

export default __exports__